define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/Deferred",
	"csi/_base/underscore"
], function(declare,lang,Deferred,_) {

	return declare(null, {

	    getRequest: function() {
	        // summary: we don't have a usual request to the server
	        return null;
	    },

		_createQueryRequest: function(/*Object?*/query, /*Object?*/options) {
			// summary: generate Deferred that will be resolved when store is complete -
			// force it to be asynchronous to work with csi/store/Request "query" method so that
			// it is not resolved before _dfdQueries is populated

			if (!this.isLoaded()) {
				var	dfd = new Deferred();
				_.defer(lang.hitch(this, this._resolveData, dfd));
				return dfd;
			}

			return null;
		},

		_resolveData: function(/*Deferred*/dfd) {
			// summary: extension point to calculate store data asynchronously
			dfd.resolve([]);
		}
	});
});